import React, { useState, useCallback } from "react";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import Footer from "./components/Footer";
import ContactSection from "./components/ContactSection";
import DownloadSection from "./components/Download";
import { BrowserRouter } from "react-router-dom";
import SubscriptionSection from "./components/SubscriptionSection";
import ChoosePepli from "./components/ChoosePepli";
import FAQSection from "./components/FAQ";
import WhyChoosePepli from "./components/WhyChoosePepli";
import AnnouncementBar from "./components/AnnouncementBar";
import ArtistTickerSection from "./components/ArtistTickerSection";
import ReviewsSection from "./components/ReviewsSection";
import AppShowcase from "./components/AppShowcase";

function App() {
  const [barHeight, setBarHeight] = useState(0);
  const handleBarHeight = useCallback((h) => setBarHeight(h), []);

  return (
    <div className="App">
      <BrowserRouter>
        <AnnouncementBar onHeightChange={handleBarHeight} />
        <Header barHeight={barHeight} />
        <div style={{ paddingTop: barHeight }}>
          <HeroSection />
          <ChoosePepli />
          <ArtistTickerSection />
          <AppShowcase />
          <FeaturesSection />
          <WhyChoosePepli />
          {/* <DownloadSection /> */}
          <SubscriptionSection />
          <FAQSection />
          <ReviewsSection />
          <ContactSection />
          <Footer />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
